import { Card, Alert, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export function Forbidden() {
  const navigate = useNavigate();

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center py-5 px-3"
      style={{ minHeight: "60vh" }}
    >
      <Card
        className="border-0 rounded-3 shadow"
        style={{ maxWidth: "420px", width: "100%" }}
      >
        <Card.Body className="p-4">
          <div className="text-center mb-3">
            <span
              role="img"
              aria-label="Locked"
              style={{ fontSize: "2.5rem", color: "#6c757d" }}
            >
              🔒
            </span>
          </div>

          <p
            className="text-uppercase fw-semibold mb-1"
            style={{ fontSize: "12px", letterSpacing: "0.06em", color: "#b45309" }}
          >
            Access Restricted
          </p>

          <h4 className="text-center fw-medium text-dark mb-3">
            Permission Required
          </h4>

          <Alert variant="light" className="border text-center p-3 rounded-3 mb-3">
            <p className="fw-normal text-dark mb-0">
              Your user role does not grant permission to view this section.
              Contact your system administrator to adjust your role privileges.
            </p>
          </Alert>

          <p className="text-center text-muted small mb-3">
            Please contact your system administrator or review your user
            permissions for access.
          </p>

          <div className="d-grid gap-2">
            <Button
              variant="btn btn-default"
              size="sm"
              onClick={() => navigate("/dashboard")}
            >
              Return to Dashboard
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
